import styled from 'styled-components'

export const Container = styled.div`
  width: 100%;
  background-color: #f4f4f4;
  padding: 0 0 2rem 0;
`

export const Header = styled.div`
  background-color: #fff;
  padding: 1.3rem 2rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1.5rem;
  border-radius: 0.8rem;
  
  @media (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
    gap: 1rem;
    padding: 1rem 2rem;
  }
`

export const Title = styled.h2`
  font-size: 1.4rem;
  font-weight: 700;
  color: #303030;
  margin: 0;
  width: fit-content;
  padding-right: 1rem;
  margin-right: 1rem;
  border-right: 1px solid #EBEBEB;
`

export const ButtonGroup = styled.div`
  display: flex;
  gap: 1rem;
  
  @media (max-width: 768px) {
    width: 100%;
    flex-direction: column;
  }
`

export const Content = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  padding: 0 0 32px 0;
  background-color: #f4f4f4;
`

export const NewButton = styled.button`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.75rem 1.5rem;
  background-color: #0096d6;
  color: white;
  border: none;
  border-radius: 100px;
  font-size: 14px;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover {
    background-color: #0084c1;
  }
`




export const InfoMessage = styled.div`
  padding: 2rem;
  text-align: center;
  background-color: white;
  border-radius: 12px;
  color: #6b7280;
  font-size: 1rem;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06);
`



export const BlurBackground = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(4px);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
`
export const MainContainer = styled.div`
  background-color: #f4f4f4;
  padding-bottom: 2rem;
  overflow-y: auto;
  max-height: calc(100vh - 150px);  
  
  ::-webkit-scrollbar {
    width: 8px;
    height: 8px;
  }
  ::-webkit-scrollbar-track {
    background: #c0c0c0;
    border-radius: 10px;
  }
  ::-webkit-scrollbar-thumb {
    background-color: #ffffff;
    border-radius: 10px;
    border: 2px solid #c0c0c0;
  }
`